import { render, staticRenderFns } from "./ImsViewer.vue?vue&type=template&id=aede178a&scoped=true"
import script from "./ImsViewer.vue?vue&type=script&lang=js"
export * from "./ImsViewer.vue?vue&type=script&lang=js"
import style0 from "./ImsViewer.vue?vue&type=style&index=0&id=aede178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede178a",
  null
  
)

export default component.exports